import { proStudioUrqlGql as urqlGql } from '@pypestream/api-services';
import { throwErrorWithId } from '@pypestream/utils';

import { checkForErrors } from '../../utils';
import { ProStudioContext, ProStudioEvents } from '../prostudio.xstate.types';
import {
  ApiCredentialsData,
  loadApiCredentialsData,
} from './load-api-credentials';

/** Deletes an API key (by its key string), then re-fetches all credentials. */
export const deleteApiCredential = async (
  ctx: ProStudioContext,
  event: ProStudioEvents
): Promise<(ApiCredentialsData & { cb?: () => void }) | void> => {
  if (event.type !== 'deleteApiCredential') {
    return;
  }

  const projectId = ctx.project?.id;
  const customerId = ctx.project?.projectProStudioSetting?.customerId;

  if (!projectId || !customerId) {
    throwErrorWithId('Project ID and Customer ID are required');
    return;
  }

  const { id, pypeId, env, cb } = event.payload;

  const deleteMutation = {
    live: urqlGql.deletePypeKeyLive,
    sandbox: urqlGql.deletePypeKeySandbox,
  }[env];

  const response = await deleteMutation({ projectId, customerId, id, pypeId });
  checkForErrors(response);

  const data = await loadApiCredentialsData(ctx);

  return { ...data, cb };
};
